import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Building2, UserCircle, MessageCircle } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { employees } from '../data';
export function ProfilePage() {
  const {
    id
  } = useParams();
  const person = employees.find(e => e.id === id);
  if (!person) {
    return <div className="text-center py-20" data-id="element-618" data-mp="y1t475e0mmrx">
        <p className="text-navy-500 mb-4" data-id="element-619" data-mp="y344gv895cea">That person couldn't be found.</p>
        <Link to="/people" className="text-gold-600 font-semibold" data-id="element-620" data-mp="130clutlktceh">
          Back to People
        </Link>
      </div>;
  }
  const reports = employees.filter(e => e.manager === person.name);
  const teammates = employees.filter(e => e.department === person.department && e.id !== person.id).slice(0, 4);
  return <div className="max-w-3xl mx-auto" data-id="element-621" data-mp="fas4ug8zgp7u">
      <PageHeader title="" backTo="/people" backLabel="Back to People" data-id="element-622" data-mp="kaeiurwmy9hp" />

      <div className="bg-white rounded-2xl border border-navy-100 overflow-hidden" data-id="element-623" data-mp="k8jybepa0je5">
        <div className="h-28 bg-navy-600" data-id="element-624" data-mp="336sfkrzf1dj2" />
        <div className="px-6 pb-6" data-id="element-625" data-mp="2y88usuwk67sa">
          <img src={person.avatar} alt={person.name} className="w-28 h-28 rounded-full object-cover ring-4 ring-white -mt-14" data-id="element-626" data-mp="2y9a4auxxem7w" />
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mt-3" data-id="element-627" data-mp="2oiyzz7abyb0h">
            <div data-id="element-628" data-mp="2khdewynn6qf7">
              <h1 className="text-2xl font-serif font-bold text-navy-900" data-id="element-629" data-mp="2khvk4ksa8ez9">
                {person.name}
              </h1>
              <p className="text-navy-500" data-id="element-630" data-mp="2fg68p415dzan">{person.title}</p>
            </div>
            <div className="flex gap-2" data-id="element-631" data-mp="2ajphu22kd6tv">
              <a href={`mailto:${person.email}`} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-bold text-navy-900 bg-gold-500 rounded-lg hover:bg-gold-400 transition-colors" data-id="element-632" data-mp="2akqx6iqm4fhe">
                <Mail className="w-4 h-4" data-id="element-633" data-mp="3ryiixrx3ni9" /> Email
              </a>
              <button className="inline-flex items-center gap-2 px-4 py-2 text-sm font-bold text-navy-700 bg-navy-50 rounded-lg hover:bg-navy-100 transition-colors" data-id="element-634" data-mp="3qdkgy6e9mfn">
                <MessageCircle className="w-4 h-4" data-id="element-635" data-mp="230q0e1ynxpd5" /> Message
              </button>
            </div>
          </div>

          <dl className="grid sm:grid-cols-2 gap-4 mt-6 pt-6 border-t border-navy-100 text-sm" data-id="element-636" data-mp="1o861xemgk621">
            <div className="flex items-center gap-3" data-id="element-637" data-mp="1t796yz2fuca0">
              <Building2 className="w-5 h-5 text-navy-400" data-id="element-638" data-mp="2gyn0h8cbsdwk" />
              <div data-id="element-639" data-mp="2gx3fj4fq5eog">
                <dt className="text-navy-400 text-xs" data-id="element-640" data-mp="2lyj4h7l0w5c4">Department</dt>
                <dd className="font-semibold text-navy-900" data-id="element-641" data-mp="2lvn6xkd37io7">
                  {person.department}
                </dd>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-642" data-mp="2bys62utcd66r">
              <MapPin className="w-5 h-5 text-navy-400" data-id="element-643" data-mp="wj2xnyukmvpe" />
              <div data-id="element-644" data-mp="whi2c70fn8qh">
                <dt className="text-navy-400 text-xs" data-id="element-645" data-mp="wl5y7ctco78d">Location</dt>
                <dd className="font-semibold text-navy-900" data-id="element-646" data-mp="10lg28jxl0nkl">
                  {person.location}
                </dd>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-647" data-mp="o22i7haumod8">
              <Mail className="w-5 h-5 text-navy-400" data-id="element-648" data-mp="o1j0o1p421zq" />
              <div data-id="element-649" data-mp="12zuywcs4tit0">
                <dt className="text-navy-400 text-xs" data-id="element-650" data-mp="12ya36ju2zttk">Email</dt>
                <dd className="font-semibold text-navy-900" data-id="element-651" data-mp="y08ixvkx5ogi">{person.email}</dd>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-652" data-mp="aa4ke2ml8ewd">
              <Phone className="w-5 h-5 text-navy-400" data-id="element-653" data-mp="a8jnw7gpqlvv" />
              <div data-id="element-654" data-mp="5cciqgw55eez">
                <dt className="text-navy-400 text-xs" data-id="element-655" data-mp="5d4cdm66h22m">Phone</dt>
                <dd className="font-semibold text-navy-900" data-id="element-656" data-mp="k0z7183qxgic">{person.phone}</dd>
              </div>
            </div>
            {person.manager && <div className="flex items-center gap-3" data-id="element-657" data-mp="f8ftgb526ldj">
                <UserCircle className="w-5 h-5 text-navy-400" data-id="element-658" data-mp="3nor0r73a9iv4" />
                <div data-id="element-659" data-mp="3nn7orsonttz5">
                  <dt className="text-navy-400 text-xs" data-id="element-660" data-mp="3iqzb6jq428u3">Reports to</dt>
                  <dd className="font-semibold text-navy-900" data-id="element-661" data-mp="3iomue9w3a4im">
                    {person.manager}
                  </dd>
                </div>
              </div>}
          </dl>
        </div>
      </div>

      {reports.length > 0 && <div className="mt-8" data-id="element-662" data-mp="2uypmkeodr9ny">
          <h2 className="text-lg font-serif font-bold text-navy-900 mb-3" data-id="element-663" data-mp="2uyfwys78z4is">
            Direct Reports
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-664" data-mp="2zsbszp3yahbb">
            {reports.map(r => <Link key={r.id} to={`/people/${r.id}`} className="flex items-center gap-2 bg-white rounded-lg border border-navy-100 p-3 hover:border-gold-400 transition-colors" data-id="element-665" data-mp="34rwt42uuwvpm">
                <img src={r.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-666" data-mp="3ioa7h343ggzv" />
                <div className="min-w-0" data-id="element-667" data-mp="1jcqzaqqm7cr9">
                  <p className="text-sm font-semibold text-navy-900 truncate" data-id="element-668" data-mp="1jdscp1v3sbc5">
                    {r.name}
                  </p>
                  <p className="text-xs text-navy-400 truncate" data-id="element-669" data-mp="1od56k6ke6io8">{r.title}</p>
                </div>
              </Link>)}
          </div>
        </div>}

      {teammates.length > 0 && <div className="mt-8" data-id="element-670" data-mp="171zns64cn7fn">
          <h2 className="text-lg font-serif font-bold text-navy-900 mb-3" data-id="element-671" data-mp="17184nurxv269">
            In {person.department}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-672" data-mp="1247zrn6ts5gq">
            {teammates.map(t => <Link key={t.id} to={`/people/${t.id}`} className="flex items-center gap-2 bg-white rounded-lg border border-navy-100 p-3 hover:border-gold-400 transition-colors" data-id="element-673" data-mp="1zq5agyeyr6i4">
                <img src={t.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-674" data-mp="1lqw2gm0wvip8" />
                <div className="min-w-0" data-id="element-675" data-mp="1lsysv75z7duh">
                  <p className="text-sm font-semibold text-navy-900 truncate" data-id="element-676" data-mp="edknkppvmtod">
                    {t.name}
                  </p>
                  <p className="text-xs text-navy-400 truncate" data-id="element-677" data-mp="aa5uoyguaiti">{t.title}</p>
                </div>
              </Link>)}
          </div>
        </div>}
    </div>;
}